export const getB2bApiRequest = (state) => state.entities.b2bApiRequest;
